import React, { createContext, useContext, useState, useCallback } from 'react';

const TourBuilderContext = createContext(null);

export const TourBuilderProvider = ({ children }) => {
  // Global modal open state — any page can open the search flow
  const [isOpen, setIsOpen] = useState(false);

  const openBuilder  = useCallback(() => setIsOpen(true),  []);
  const closeBuilder = useCallback(() => setIsOpen(false), []);

  // Home page still registers its inline trigger so the hero "Open Builder"
  // button and the search bar scroll-into-view behaviour still work on home
  const [inlineTriggerFn, setInlineTriggerFn] = useState(null);
  const registerTrigger = useCallback((fn) => setInlineTriggerFn(() => fn), []);
  const clearTrigger    = useCallback(() => setInlineTriggerFn(null), []);

  // When the floating button is clicked:
  // - On home page: fire the inline search bar (scroll + open)
  // - On any other page: open the global modal overlay
  const trigger = useCallback(() => {
    if (inlineTriggerFn) {
      inlineTriggerFn();
    } else {
      setIsOpen(true);
    }
  }, [inlineTriggerFn]);

  return (
    <TourBuilderContext.Provider value={{
      isOpen, openBuilder, closeBuilder,
      registerTrigger, clearTrigger,
      trigger,
    }}>
      {children}
    </TourBuilderContext.Provider>
  );
};

export const useTourBuilder = () => useContext(TourBuilderContext);